import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './side/Sidebar';
import TopHeader from './side/TopHeader';
import ErrorPopup from './side/ErrorPopup';
import '../css/NoticeWrite.css';
import { SERVER_URL } from '../../config/config';

const NoticeEdit = () => {
  const navigate = useNavigate();
  const { noticeId } = useParams();
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [error, setError] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  useEffect(() => {
    fetchNoticeDetail();
  }, [noticeId]);

  const fetchNoticeDetail = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/admin/notice/${noticeId}`);
      if (response.data.result_code === 201) {
        const notice = response.data.notice;
        setTitle(notice.title);
        setContent(notice.content);
      }
    } catch (error) {
      console.error('Error fetching notice detail:', error);
      setError('공지사항을 불러오는데 실패했습니다.');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const adminId = localStorage.getItem('adminId');
      if (!adminId) {
        setError('로그인이 필요합니다. 다시 로그인해주세요.');
        return;
      }

      if (!title.trim() || !content.trim()) {
        setError('제목과 내용을 모두 입력해주세요.');
        return;
      }

      const response = await axios.put(`${SERVER_URL}/admin/notice/${noticeId}`, {
        admin_id: adminId,
        title: title.trim(),
        content: content.trim()
      });

      if (response.data.result_code === 200) {
        setShowSuccessPopup(true);
      } else {
        setError(response.data.message || '공지사항 수정에 실패했습니다.');
      }
    } catch (error) {
      console.error('Error updating notice:', error);
      if (error.response && error.response.data && error.response.data.message) {
        setError(error.response.data.message);
      } else {
        setError('공지사항 수정에 실패했습니다.');
      }
    }
  };

  const handleSuccessPopupClose = () => {
    setShowSuccessPopup(false);
    navigate('/admin/notice');
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
        <div className="main-content">
          <div className="detail-header">
            <button className="back-button" onClick={handleBack}>
              ← 목록으로
            </button>
            <h1>공지사항 수정</h1>
          </div>
          <form className="detail-content" onSubmit={handleSubmit}>
            <div className="detail-row">
              <div className="detail-label">제목</div>
              <div className="detail-value">
                <input
                  type="text"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  placeholder="공지사항 제목을 입력하세요"
                  required
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd' }}
                />
              </div>
            </div>
            <div className="detail-row">
              <div className="detail-label">내용</div>
              <div className="detail-value">
                <textarea
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  placeholder="공지사항 내용을 입력하세요"
                  required
                  rows={10}
                  style={{ width: '100%', padding: '10px', borderRadius: '8px', border: '1px solid #ddd', resize: 'vertical' }}
                />
              </div>
            </div>
            <div className="inquiry-answer-button-group">
              <button type="submit" className="answer-button" style={{ position: 'absolute', right: '170px' }}>
                수정
              </button>
              <button type="button" className="back-button" onClick={handleBack}>
                취소
              </button>
            </div>
          </form>
        </div>
      </div>
      {showSuccessPopup && (
        <ErrorPopup
          message="공지사항이 성공적으로 수정되었습니다."
          onClose={handleSuccessPopupClose}
        />
      )}
    </div>
  );
};

export default NoticeEdit; 